import { render, staticRenderFns } from "./mendianshoukuan.vue?vue&type=template&id=d9a84c38"
import script from "./mendianshoukuan.vue?vue&type=script&lang=js"
export * from "./mendianshoukuan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports